import { shallowRef, computed, onScopeDispose, type ComputedRef } from 'vue'
import type { Snapshot } from 'valtio/vanilla'
import { snapshot, subscribe } from '@klausapp/state/valtio'

// Vue reads snapshots; mutations target the Valtio proxy.
export function valtioBridge<T extends object>(state: T): ComputedRef<Snapshot<T>> {
  const snapshotRef = shallowRef(snapshot(state))
  const unsubscribe = subscribe(state, () => {
    snapshotRef.value = snapshot(state)
  })
  onScopeDispose(unsubscribe, true)
  return computed(() => snapshotRef.value)
}
